class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.overlay = this.querySelector(".cart-nofication-overlay");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add("animate", "active");
    this.classList.add("active--notification");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    this.classList.remove("active--notification");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.variant_id;

    // Item removed
    if (parsedState.items_removed && parsedState.items_removed.length > 0) {
      this.cartItemKey = parsedState.items_removed[0]["variant_id"];

      // Item added
    } else if (parsedState.items_added && parsedState.items_added.length > 0) {
      this.cartItemKey = parsedState.items_added[0]["variant_id"];
    }

    this.getSectionsToRender().forEach((section) => {
      var content = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
      var currentElm = document.getElementById(section.id);
      if (currentElm) {
        currentElm.innerHTML = content;
      }

      if (currentElm && section.id == "cart-notification-product" && content == "") {
        currentElm.innerHTML =
          "<span class='remove-item__notification'>Item removed from the cart</span>";
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        section: "cart-notification-product",
        selector: `[id*="cart-notification-product-${this.cartItemKey}"]`,
      },
      // {
      //   id: "cart-notification-button",
      //   section: "cart-notification-button",
      //   selector: "#shopify-section-cart-notification-button",
      // },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: "#shopify-section-cart-icon-bubble",
      },
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: "#CartDrawer",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    var content = new DOMParser().parseFromString(html, "text/html");
    return content.querySelector(selector)?.innerHTML || "";
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      (target !== this.notification && !target.closest("cart-notification")) ||
      target == this.overlay
    ) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById("cart-notification-product");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`.loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`.loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    // this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById("cart-notification-product");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(`.loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`.loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add("hidden"));
  }

  updateQuantity(line, quantity, name) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    this.enableLoading(line);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((response) => {
        this.renderContents(response);

        var cartDrawer = document.querySelector("cart-drawer");
        if (response.item_count == 0) {
          cartDrawer?.classList.add("is-empty");
        } else {
          cartDrawer?.classList.remove("is-empty");
        }
      })
      .catch(() => {})
      .finally(() => {
        this.disableLoading(line);
      });
  }
}

customElements.define("cart-notification", CartNotification);

// Cart Remove Minicart Button
class CartRemoveButtonMinicart extends HTMLElement {
  constructor() {
    super();
    this?.addEventListener("click", (event) => {
      event.preventDefault();
      const notification_cart = this.closest("cart-notification");
      if (notification_cart) {
        notification_cart.updateQuantity.bind(notification_cart)(this.dataset.index, 0);
      }
    });
  }
}

customElements.define("cart-remove-button-minicart", CartRemoveButtonMinicart);

// Cart Remove Minicart Button
class QuantityInputMinicart extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.notification_cart = this.closest("cart-notification");

    this.input?.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onInputChange(event) {
    const value = parseInt(this.input.value);
    var remove_button = this.notification_cart?.querySelector("cart-remove-button-minicart");

    if (remove_button) {
      this.notification_cart.updateQuantity.bind(this.notification_cart)(
        remove_button.dataset.index,
        value
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const bby04BodyCls = document.body.classList.contains("bby-4-cart-updates");

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (
      event.target.name === "minus" &&
      previousValue == 1 &&
      bby04BodyCls &&
      previousValue == this.input.value
    ) {
      this.input.value = 0;
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input-minicart", QuantityInputMinicart);
